import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAppIconSpec, LazyAppIcon, LazyCardSpec, LazyCard, LazyCreateNewClaimHyperlinkSpec, LazyCreateNewClaimHyperlink, LazyIconCardSpec, LazyIconCard, LazyShipmentCardSpec, LazyShipmentCard, LazyShippingAddress, LazyStepSubtitleSpec, LazyStepSubtitle, LazyParcelLab, LazyDropAreaSpec, LazyDropArea, LazyMediaUploaderSpec, LazyMediaUploader, LazyBaseModalSpec, LazyBaseModal, LazyCollectSignatureModalSpec, LazyCollectSignatureModal, LazyEditInStoreDetailsModal, LazyEditShippingAddressModalSpec, LazyEditShippingAddressModal, LazyItemsModalSpec, LazyItemsModal, LazyOtaModalSpec, LazyOtaModal, LazyOutOfWarrantyModal, LazyProcessFileClaim, LazyProcessReturnsSpec, LazyProcessReturns, LazyProcessShippingClaimsSpec, LazyProcessShippingClaims, LazyProcessWarrantyClaims, LazyReturnsCardSpec, LazyReturnsCard, LazyShippingClaimsCardSpec, LazyShippingClaimsCard, LazyPulseConfirmShippingAddress, LazyPulseDeliveryIssueDetails, LazyPulseDeliveryIssueDropdown, LazyPulseDeliveryIssueOptions, LazyPulseItemCard, LazyPulseItemIssueCard, LazyPulseItemIssueDetailModal, LazyPulseItemIssueDetailModalForm, LazyPulseItemIssueDetailModalProgressBar, LazyPulseItemIssueDetailModalSelectCount, LazyPulseItemIssueDetailModalSelectGranularity, LazyPulseItemIssueDetails, LazyPulseOrderIssueOptions, LazyPulseRendered, LazyPulseResolutionOptions, LazyPulseSearchWarrantyProductsModal, LazyPulseBadge, LazyPulseEmptyState, LazyPulseLoadingSpinner, LazyPulseMediaCarousel, LazyPulseTooltip, LazyPulseBanner, LazyPulseBaseModal, LazyPulseChatAttachment, LazyPulseClaimFeed, LazyPulseClaimMetric, LazyPulseCustomerAddress, LazyPulseCustomerAddresses, LazyPulseDataMetric, LazyPulseFeedback, LazyPulseFulfillmentInfo, LazyPulseInfoBanner, LazyPulseMessagingEvent, LazyPulseMessagingEventDivider, LazyPulseMessagingFeed, LazyPulseModal, LazyPulsePlatformAvatar, LazyPulseProductDisplay, LazyPulseReshipRefundResolutionDetails, LazyPulseStatusBadge, LazyPulseSuccessBanner, LazyPulseTagList, LazyPulseToggleDisplay, LazyPulseTrackingInfo, LazyPulseUserAvatar, LazyPulseWarningBanner, LazyPulseTable, LazyPulseTableGridSkeleton, LazyPulseTableSkeleton, LazyPulseAddBook, LazyPulseApiLogo, LazyPulseArmraLogo, LazyPulseArrowsRightLeft, LazyPulseBigCommerce, LazyPulseCart, LazyPulseCheckCircle, LazyPulseCheckoutBag, LazyPulseChevronLeft, LazyPulseCircleLogo, LazyPulseClaimInfoSubscribedRightArrows, LazyPulseClaimTodoApprovedDeniedSolidArrow, LazyPulseClaimTodoClosedSolidArrow, LazyPulseClaimTodoDashedArrow, LazyPulseClaimTodoOnholdDashedArrow, LazyPulseClaimTodoPendingDashedArrow, LazyPulseClaimTodoSolidLine, LazyPulseDatePicker, LazyPulseEarthGlobeTimezone, LazyPulseFolderCheck, LazyPulseFollowUp, LazyPulseIconApprove, LazyPulseIconArmra, LazyPulseIconAvatar, LazyPulseIconBuilding, LazyPulseIconCheck, LazyPulseIconClose, LazyPulseIconCreditCard, LazyPulseIconCustom, LazyPulseIconDanger, LazyPulseIconDollar, LazyPulseIconDrag, LazyPulseIconEdit, LazyPulseIconGoogle, LazyPulseIconInfo, LazyPulseIconLock, LazyPulseIconLogo, LazyPulseIconRefund, LazyPulseIconSave, LazyPulseIconSend, LazyPulseIconShipment, LazyPulseIconShopify, LazyPulseIconWarning, LazyPulseImageCancel, LazyPulseInbox, LazyPulseLineAlign, LazyPulseLineAlphabet, LazyPulseLineAngleDoubleLeft, LazyPulseLineAngleDoubleRight, LazyPulseLineAngleDown, LazyPulseLineAngleLeft, LazyPulseLineAngleRight, LazyPulseLineAngleUp, LazyPulseLineAppleAlt, LazyPulseLineArchive, LazyPulseLineArrow, LazyPulseLineArrowDownRight, LazyPulseLineArrowLeft, LazyPulseLineArrowRight, LazyPulseLineBars, LazyPulseLineBold, LazyPulseLineBolt, LazyPulseLineBookMedical, LazyPulseLineBox, LazyPulseLineBuilding, LazyPulseLineCameraPlus, LazyPulseLineCameraQuestion, LazyPulseLineChart, LazyPulseLineChatBubbleUser, LazyPulseLineCheckCircle, LazyPulseLineClipboardAlt, LazyPulseLineCodeBranch, LazyPulseLineCoins, LazyPulseLineCommentAlt, LazyPulseLineCommentAltBlock, LazyPulseLineCommentDots, LazyPulseLineCommentMessage, LazyPulseLineCommentQuestion, LazyPulseLineComparison, LazyPulseLineCopy, LazyPulseLineCornerUpLeftAlt, LazyPulseLineCornerUpRightAlt, LazyPulseLineCreditCard, LazyPulseLineDashboard, LazyPulseLineDownloadAlt, LazyPulseLineDraggabledots, LazyPulseLineEllipsisH, LazyPulseLineExclamationCircle, LazyPulseLineExclamationOctagon, LazyPulseLineExport, LazyPulseLineExternalLinkAlt, LazyPulseLineEye, LazyPulseLineEyeSlash, LazyPulseLineFileCopyAlt, LazyPulseLineFileLandscape, LazyPulseLineFilter, LazyPulseLineFire, LazyPulseLineFolder, LazyPulseLineFolderOpen, LazyPulseLineFont, LazyPulseLineGithubAlt, LazyPulseLineGlobe, LazyPulseLineImage, LazyPulseLineImageBroken, LazyPulseLineImport, LazyPulseLineInfoCircle, LazyPulseLineItalic, LazyPulseLineLeftIndent, LazyPulseLineLinkAlt, LazyPulseLineListOl, LazyPulseLineListUl, LazyPulseLineLock, LazyPulseLineMessage, LazyPulseLineMinusCircle, LazyPulseLineMoney, LazyPulseLineMoneyWithdraw, LazyPulseLineMoon, LazyPulseLineMultiply, LazyPulseLinePalette, LazyPulseLinePaperclip, LazyPulseLinePen, LazyPulseLinePhone, LazyPulseLinePlus, LazyPulseLinePlusCircle, LazyPulseLinePlusSquare, LazyPulseLineRefresh, LazyPulseLineRightIndentAlt, LazyPulseLineRocket, LazyPulseLineSearch, LazyPulseLineSetting, LazyPulseLineShield, LazyPulseLineShieldCheck, LazyPulseLineSlack, LazyPulseLineSort, LazyPulseLineStar, LazyPulseLineSun, LazyPulseLineSwatchbook, LazyPulseLineSync, LazyPulseLineTable, LazyPulseLineTag, LazyPulseLineTimes, LazyPulseLineTimesCircle, LazyPulseLineToggleOff, LazyPulseLineToggleOn, LazyPulseLineTransaction, LazyPulseLineTrashAlt, LazyPulseLineUnderline, LazyPulseLineUpload, LazyPulseLineUsdCircle, LazyPulseLineUsersAlt, LazyPulseLineWrench, LazyPulseLoopreturns, LazyPulseMagentoLogo, LazyPulseNoResponse, LazyPulseOutlineCube, LazyPulseOutlineEnvelope, LazyPulseOutsideOp, LazyPulsePackage, LazyPulsePackageArrived, LazyPulsePlayCircle, LazyPulsePlusCircle, LazyPulseQueueList, LazyPulseRefreshResentMail, LazyPulseShieldCheck, LazyPulseShipstation, LazyPulseShopifyAvatar, LazyPulseShopifyBag, LazyPulseSolidStar, LazyPulseTableDeleteColumn, LazyPulseTableDeleteRow, LazyPulseTableInsertColumnAfter, LazyPulseTableInsertColumnBefore, LazyPulseTableInsertRowAbove, LazyPulseTableInsertRowAfter, LazyPulseTableOptions, LazyPulseTableSettings, LazyPulseTipaltiLogo, LazyPulseXCircle, LazyPulseXMark, LazyPulseAccordionCard, LazyPulseBasicCard, LazyPulsePageIcon, LazyPulseShippingClaim, LazyPulseSingleClaim, LazyPulseTabbedNav, LazyPulseWarrantyClaim, LazyPulseButton, LazyPulseButtonCard, LazyPulseChatImageUploader, LazyPulseColorInput, LazyPulseCustomDatePicker, LazyPulseDateRangePicker, LazyPulseDropdown, LazyPulseIconButton, LazyPulseInput, LazyPulseLabelPopper, LazyPulseMessageBox, LazyPulseMultiDropdown, LazyPulseMultiSelectDropdown, LazyPulseOptionsMenu, LazyPulsePasswordInput, LazyPulseRadioButton, LazyPulseRadioQuestion, LazyPulseRteFileComponent, LazyPulseRteVideoComponent, LazyPulseRichTextEditor, LazyPulseSelect, LazyPulseTagSelect, LazyPulseTextArea, LazyPulseToggle, LazyPulseValidationGroup } from '#components'
const lazyGlobalComponents = [
  ["AppIconSpec", LazyAppIconSpec],
["AppIcon", LazyAppIcon],
["CardSpec", LazyCardSpec],
["Card", LazyCard],
["CreateNewClaimHyperlinkSpec", LazyCreateNewClaimHyperlinkSpec],
["CreateNewClaimHyperlink", LazyCreateNewClaimHyperlink],
["IconCardSpec", LazyIconCardSpec],
["IconCard", LazyIconCard],
["ShipmentCardSpec", LazyShipmentCardSpec],
["ShipmentCard", LazyShipmentCard],
["ShippingAddress", LazyShippingAddress],
["StepSubtitleSpec", LazyStepSubtitleSpec],
["StepSubtitle", LazyStepSubtitle],
["ParcelLab", LazyParcelLab],
["DropAreaSpec", LazyDropAreaSpec],
["DropArea", LazyDropArea],
["MediaUploaderSpec", LazyMediaUploaderSpec],
["MediaUploader", LazyMediaUploader],
["BaseModalSpec", LazyBaseModalSpec],
["BaseModal", LazyBaseModal],
["CollectSignatureModalSpec", LazyCollectSignatureModalSpec],
["CollectSignatureModal", LazyCollectSignatureModal],
["EditInStoreDetailsModal", LazyEditInStoreDetailsModal],
["EditShippingAddressModalSpec", LazyEditShippingAddressModalSpec],
["EditShippingAddressModal", LazyEditShippingAddressModal],
["ItemsModalSpec", LazyItemsModalSpec],
["ItemsModal", LazyItemsModal],
["OtaModalSpec", LazyOtaModalSpec],
["OtaModal", LazyOtaModal],
["OutOfWarrantyModal", LazyOutOfWarrantyModal],
["ProcessFileClaim", LazyProcessFileClaim],
["ProcessReturnsSpec", LazyProcessReturnsSpec],
["ProcessReturns", LazyProcessReturns],
["ProcessShippingClaimsSpec", LazyProcessShippingClaimsSpec],
["ProcessShippingClaims", LazyProcessShippingClaims],
["ProcessWarrantyClaims", LazyProcessWarrantyClaims],
["ReturnsCardSpec", LazyReturnsCardSpec],
["ReturnsCard", LazyReturnsCard],
["ShippingClaimsCardSpec", LazyShippingClaimsCardSpec],
["ShippingClaimsCard", LazyShippingClaimsCard],
["PulseConfirmShippingAddress", LazyPulseConfirmShippingAddress],
["PulseDeliveryIssueDetails", LazyPulseDeliveryIssueDetails],
["PulseDeliveryIssueDropdown", LazyPulseDeliveryIssueDropdown],
["PulseDeliveryIssueOptions", LazyPulseDeliveryIssueOptions],
["PulseItemCard", LazyPulseItemCard],
["PulseItemIssueCard", LazyPulseItemIssueCard],
["PulseItemIssueDetailModal", LazyPulseItemIssueDetailModal],
["PulseItemIssueDetailModalForm", LazyPulseItemIssueDetailModalForm],
["PulseItemIssueDetailModalProgressBar", LazyPulseItemIssueDetailModalProgressBar],
["PulseItemIssueDetailModalSelectCount", LazyPulseItemIssueDetailModalSelectCount],
["PulseItemIssueDetailModalSelectGranularity", LazyPulseItemIssueDetailModalSelectGranularity],
["PulseItemIssueDetails", LazyPulseItemIssueDetails],
["PulseOrderIssueOptions", LazyPulseOrderIssueOptions],
["PulseRendered", LazyPulseRendered],
["PulseResolutionOptions", LazyPulseResolutionOptions],
["PulseSearchWarrantyProductsModal", LazyPulseSearchWarrantyProductsModal],
["PulseBadge", LazyPulseBadge],
["PulseEmptyState", LazyPulseEmptyState],
["PulseLoadingSpinner", LazyPulseLoadingSpinner],
["PulseMediaCarousel", LazyPulseMediaCarousel],
["PulseTooltip", LazyPulseTooltip],
["PulseBanner", LazyPulseBanner],
["PulseBaseModal", LazyPulseBaseModal],
["PulseChatAttachment", LazyPulseChatAttachment],
["PulseClaimFeed", LazyPulseClaimFeed],
["PulseClaimMetric", LazyPulseClaimMetric],
["PulseCustomerAddress", LazyPulseCustomerAddress],
["PulseCustomerAddresses", LazyPulseCustomerAddresses],
["PulseDataMetric", LazyPulseDataMetric],
["PulseFeedback", LazyPulseFeedback],
["PulseFulfillmentInfo", LazyPulseFulfillmentInfo],
["PulseInfoBanner", LazyPulseInfoBanner],
["PulseMessagingEvent", LazyPulseMessagingEvent],
["PulseMessagingEventDivider", LazyPulseMessagingEventDivider],
["PulseMessagingFeed", LazyPulseMessagingFeed],
["PulseModal", LazyPulseModal],
["PulsePlatformAvatar", LazyPulsePlatformAvatar],
["PulseProductDisplay", LazyPulseProductDisplay],
["PulseReshipRefundResolutionDetails", LazyPulseReshipRefundResolutionDetails],
["PulseStatusBadge", LazyPulseStatusBadge],
["PulseSuccessBanner", LazyPulseSuccessBanner],
["PulseTagList", LazyPulseTagList],
["PulseToggleDisplay", LazyPulseToggleDisplay],
["PulseTrackingInfo", LazyPulseTrackingInfo],
["PulseUserAvatar", LazyPulseUserAvatar],
["PulseWarningBanner", LazyPulseWarningBanner],
["PulseTable", LazyPulseTable],
["PulseTableGridSkeleton", LazyPulseTableGridSkeleton],
["PulseTableSkeleton", LazyPulseTableSkeleton],
["PulseAddBook", LazyPulseAddBook],
["PulseApiLogo", LazyPulseApiLogo],
["PulseArmraLogo", LazyPulseArmraLogo],
["PulseArrowsRightLeft", LazyPulseArrowsRightLeft],
["PulseBigCommerce", LazyPulseBigCommerce],
["PulseCart", LazyPulseCart],
["PulseCheckCircle", LazyPulseCheckCircle],
["PulseCheckoutBag", LazyPulseCheckoutBag],
["PulseChevronLeft", LazyPulseChevronLeft],
["PulseCircleLogo", LazyPulseCircleLogo],
["PulseClaimInfoSubscribedRightArrows", LazyPulseClaimInfoSubscribedRightArrows],
["PulseClaimTodoApprovedDeniedSolidArrow", LazyPulseClaimTodoApprovedDeniedSolidArrow],
["PulseClaimTodoClosedSolidArrow", LazyPulseClaimTodoClosedSolidArrow],
["PulseClaimTodoDashedArrow", LazyPulseClaimTodoDashedArrow],
["PulseClaimTodoOnholdDashedArrow", LazyPulseClaimTodoOnholdDashedArrow],
["PulseClaimTodoPendingDashedArrow", LazyPulseClaimTodoPendingDashedArrow],
["PulseClaimTodoSolidLine", LazyPulseClaimTodoSolidLine],
["PulseDatePicker", LazyPulseDatePicker],
["PulseEarthGlobeTimezone", LazyPulseEarthGlobeTimezone],
["PulseFolderCheck", LazyPulseFolderCheck],
["PulseFollowUp", LazyPulseFollowUp],
["PulseIconApprove", LazyPulseIconApprove],
["PulseIconArmra", LazyPulseIconArmra],
["PulseIconAvatar", LazyPulseIconAvatar],
["PulseIconBuilding", LazyPulseIconBuilding],
["PulseIconCheck", LazyPulseIconCheck],
["PulseIconClose", LazyPulseIconClose],
["PulseIconCreditCard", LazyPulseIconCreditCard],
["PulseIconCustom", LazyPulseIconCustom],
["PulseIconDanger", LazyPulseIconDanger],
["PulseIconDollar", LazyPulseIconDollar],
["PulseIconDrag", LazyPulseIconDrag],
["PulseIconEdit", LazyPulseIconEdit],
["PulseIconGoogle", LazyPulseIconGoogle],
["PulseIconInfo", LazyPulseIconInfo],
["PulseIconLock", LazyPulseIconLock],
["PulseIconLogo", LazyPulseIconLogo],
["PulseIconRefund", LazyPulseIconRefund],
["PulseIconSave", LazyPulseIconSave],
["PulseIconSend", LazyPulseIconSend],
["PulseIconShipment", LazyPulseIconShipment],
["PulseIconShopify", LazyPulseIconShopify],
["PulseIconWarning", LazyPulseIconWarning],
["PulseImageCancel", LazyPulseImageCancel],
["PulseInbox", LazyPulseInbox],
["PulseLineAlign", LazyPulseLineAlign],
["PulseLineAlphabet", LazyPulseLineAlphabet],
["PulseLineAngleDoubleLeft", LazyPulseLineAngleDoubleLeft],
["PulseLineAngleDoubleRight", LazyPulseLineAngleDoubleRight],
["PulseLineAngleDown", LazyPulseLineAngleDown],
["PulseLineAngleLeft", LazyPulseLineAngleLeft],
["PulseLineAngleRight", LazyPulseLineAngleRight],
["PulseLineAngleUp", LazyPulseLineAngleUp],
["PulseLineAppleAlt", LazyPulseLineAppleAlt],
["PulseLineArchive", LazyPulseLineArchive],
["PulseLineArrow", LazyPulseLineArrow],
["PulseLineArrowDownRight", LazyPulseLineArrowDownRight],
["PulseLineArrowLeft", LazyPulseLineArrowLeft],
["PulseLineArrowRight", LazyPulseLineArrowRight],
["PulseLineBars", LazyPulseLineBars],
["PulseLineBold", LazyPulseLineBold],
["PulseLineBolt", LazyPulseLineBolt],
["PulseLineBookMedical", LazyPulseLineBookMedical],
["PulseLineBox", LazyPulseLineBox],
["PulseLineBuilding", LazyPulseLineBuilding],
["PulseLineCameraPlus", LazyPulseLineCameraPlus],
["PulseLineCameraQuestion", LazyPulseLineCameraQuestion],
["PulseLineChart", LazyPulseLineChart],
["PulseLineChatBubbleUser", LazyPulseLineChatBubbleUser],
["PulseLineCheckCircle", LazyPulseLineCheckCircle],
["PulseLineClipboardAlt", LazyPulseLineClipboardAlt],
["PulseLineCodeBranch", LazyPulseLineCodeBranch],
["PulseLineCoins", LazyPulseLineCoins],
["PulseLineCommentAlt", LazyPulseLineCommentAlt],
["PulseLineCommentAltBlock", LazyPulseLineCommentAltBlock],
["PulseLineCommentDots", LazyPulseLineCommentDots],
["PulseLineCommentMessage", LazyPulseLineCommentMessage],
["PulseLineCommentQuestion", LazyPulseLineCommentQuestion],
["PulseLineComparison", LazyPulseLineComparison],
["PulseLineCopy", LazyPulseLineCopy],
["PulseLineCornerUpLeftAlt", LazyPulseLineCornerUpLeftAlt],
["PulseLineCornerUpRightAlt", LazyPulseLineCornerUpRightAlt],
["PulseLineCreditCard", LazyPulseLineCreditCard],
["PulseLineDashboard", LazyPulseLineDashboard],
["PulseLineDownloadAlt", LazyPulseLineDownloadAlt],
["PulseLineDraggabledots", LazyPulseLineDraggabledots],
["PulseLineEllipsisH", LazyPulseLineEllipsisH],
["PulseLineExclamationCircle", LazyPulseLineExclamationCircle],
["PulseLineExclamationOctagon", LazyPulseLineExclamationOctagon],
["PulseLineExport", LazyPulseLineExport],
["PulseLineExternalLinkAlt", LazyPulseLineExternalLinkAlt],
["PulseLineEye", LazyPulseLineEye],
["PulseLineEyeSlash", LazyPulseLineEyeSlash],
["PulseLineFileCopyAlt", LazyPulseLineFileCopyAlt],
["PulseLineFileLandscape", LazyPulseLineFileLandscape],
["PulseLineFilter", LazyPulseLineFilter],
["PulseLineFire", LazyPulseLineFire],
["PulseLineFolder", LazyPulseLineFolder],
["PulseLineFolderOpen", LazyPulseLineFolderOpen],
["PulseLineFont", LazyPulseLineFont],
["PulseLineGithubAlt", LazyPulseLineGithubAlt],
["PulseLineGlobe", LazyPulseLineGlobe],
["PulseLineImage", LazyPulseLineImage],
["PulseLineImageBroken", LazyPulseLineImageBroken],
["PulseLineImport", LazyPulseLineImport],
["PulseLineInfoCircle", LazyPulseLineInfoCircle],
["PulseLineItalic", LazyPulseLineItalic],
["PulseLineLeftIndent", LazyPulseLineLeftIndent],
["PulseLineLinkAlt", LazyPulseLineLinkAlt],
["PulseLineListOl", LazyPulseLineListOl],
["PulseLineListUl", LazyPulseLineListUl],
["PulseLineLock", LazyPulseLineLock],
["PulseLineMessage", LazyPulseLineMessage],
["PulseLineMinusCircle", LazyPulseLineMinusCircle],
["PulseLineMoney", LazyPulseLineMoney],
["PulseLineMoneyWithdraw", LazyPulseLineMoneyWithdraw],
["PulseLineMoon", LazyPulseLineMoon],
["PulseLineMultiply", LazyPulseLineMultiply],
["PulseLinePalette", LazyPulseLinePalette],
["PulseLinePaperclip", LazyPulseLinePaperclip],
["PulseLinePen", LazyPulseLinePen],
["PulseLinePhone", LazyPulseLinePhone],
["PulseLinePlus", LazyPulseLinePlus],
["PulseLinePlusCircle", LazyPulseLinePlusCircle],
["PulseLinePlusSquare", LazyPulseLinePlusSquare],
["PulseLineRefresh", LazyPulseLineRefresh],
["PulseLineRightIndentAlt", LazyPulseLineRightIndentAlt],
["PulseLineRocket", LazyPulseLineRocket],
["PulseLineSearch", LazyPulseLineSearch],
["PulseLineSetting", LazyPulseLineSetting],
["PulseLineShield", LazyPulseLineShield],
["PulseLineShieldCheck", LazyPulseLineShieldCheck],
["PulseLineSlack", LazyPulseLineSlack],
["PulseLineSort", LazyPulseLineSort],
["PulseLineStar", LazyPulseLineStar],
["PulseLineSun", LazyPulseLineSun],
["PulseLineSwatchbook", LazyPulseLineSwatchbook],
["PulseLineSync", LazyPulseLineSync],
["PulseLineTable", LazyPulseLineTable],
["PulseLineTag", LazyPulseLineTag],
["PulseLineTimes", LazyPulseLineTimes],
["PulseLineTimesCircle", LazyPulseLineTimesCircle],
["PulseLineToggleOff", LazyPulseLineToggleOff],
["PulseLineToggleOn", LazyPulseLineToggleOn],
["PulseLineTransaction", LazyPulseLineTransaction],
["PulseLineTrashAlt", LazyPulseLineTrashAlt],
["PulseLineUnderline", LazyPulseLineUnderline],
["PulseLineUpload", LazyPulseLineUpload],
["PulseLineUsdCircle", LazyPulseLineUsdCircle],
["PulseLineUsersAlt", LazyPulseLineUsersAlt],
["PulseLineWrench", LazyPulseLineWrench],
["PulseLoopreturns", LazyPulseLoopreturns],
["PulseMagentoLogo", LazyPulseMagentoLogo],
["PulseNoResponse", LazyPulseNoResponse],
["PulseOutlineCube", LazyPulseOutlineCube],
["PulseOutlineEnvelope", LazyPulseOutlineEnvelope],
["PulseOutsideOp", LazyPulseOutsideOp],
["PulsePackage", LazyPulsePackage],
["PulsePackageArrived", LazyPulsePackageArrived],
["PulsePlayCircle", LazyPulsePlayCircle],
["PulsePlusCircle", LazyPulsePlusCircle],
["PulseQueueList", LazyPulseQueueList],
["PulseRefreshResentMail", LazyPulseRefreshResentMail],
["PulseShieldCheck", LazyPulseShieldCheck],
["PulseShipstation", LazyPulseShipstation],
["PulseShopifyAvatar", LazyPulseShopifyAvatar],
["PulseShopifyBag", LazyPulseShopifyBag],
["PulseSolidStar", LazyPulseSolidStar],
["PulseTableDeleteColumn", LazyPulseTableDeleteColumn],
["PulseTableDeleteRow", LazyPulseTableDeleteRow],
["PulseTableInsertColumnAfter", LazyPulseTableInsertColumnAfter],
["PulseTableInsertColumnBefore", LazyPulseTableInsertColumnBefore],
["PulseTableInsertRowAbove", LazyPulseTableInsertRowAbove],
["PulseTableInsertRowAfter", LazyPulseTableInsertRowAfter],
["PulseTableOptions", LazyPulseTableOptions],
["PulseTableSettings", LazyPulseTableSettings],
["PulseTipaltiLogo", LazyPulseTipaltiLogo],
["PulseXCircle", LazyPulseXCircle],
["PulseXMark", LazyPulseXMark],
["PulseAccordionCard", LazyPulseAccordionCard],
["PulseBasicCard", LazyPulseBasicCard],
["PulsePageIcon", LazyPulsePageIcon],
["PulseShippingClaim", LazyPulseShippingClaim],
["PulseSingleClaim", LazyPulseSingleClaim],
["PulseTabbedNav", LazyPulseTabbedNav],
["PulseWarrantyClaim", LazyPulseWarrantyClaim],
["PulseButton", LazyPulseButton],
["PulseButtonCard", LazyPulseButtonCard],
["PulseChatImageUploader", LazyPulseChatImageUploader],
["PulseColorInput", LazyPulseColorInput],
["PulseCustomDatePicker", LazyPulseCustomDatePicker],
["PulseDateRangePicker", LazyPulseDateRangePicker],
["PulseDropdown", LazyPulseDropdown],
["PulseIconButton", LazyPulseIconButton],
["PulseInput", LazyPulseInput],
["PulseLabelPopper", LazyPulseLabelPopper],
["PulseMessageBox", LazyPulseMessageBox],
["PulseMultiDropdown", LazyPulseMultiDropdown],
["PulseMultiSelectDropdown", LazyPulseMultiSelectDropdown],
["PulseOptionsMenu", LazyPulseOptionsMenu],
["PulsePasswordInput", LazyPulsePasswordInput],
["PulseRadioButton", LazyPulseRadioButton],
["PulseRadioQuestion", LazyPulseRadioQuestion],
["PulseRteFileComponent", LazyPulseRteFileComponent],
["PulseRteVideoComponent", LazyPulseRteVideoComponent],
["PulseRichTextEditor", LazyPulseRichTextEditor],
["PulseSelect", LazyPulseSelect],
["PulseTagSelect", LazyPulseTagSelect],
["PulseTextArea", LazyPulseTextArea],
["PulseToggle", LazyPulseToggle],
["PulseValidationGroup", LazyPulseValidationGroup],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
